<template>
    <div style="background-color: #fafafa;">
        <van-nav-bar left-text="返回"  left-arrow @click-left="onClickLeft"></van-nav-bar>
        <van-tabs v-model="selected" type="card" color="#1890ff" sticky swipeable @click="switchTab">
            <van-tab title="产品列表">
                <van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch(0)" @input="onSearch(0)"
                            @cancel="onSearch(0)" @clear="onSearch(0)">
                    <div slot="action" @click="onSearch(0)">搜索</div>
                </van-search>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(0)">
                    <van-list v-model="loading" :finished="finished" @load="getSkuList" class="listBox"  finished-text="没有更多了">
                        <div v-for="item in list" class="card" :key="item.uuid" @click="openMainDetail(item)">
                            <table class="layout">
                                <tr>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{item.name}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span>类型：</span>
                                            <span>{{item.typeName}}</span>
                                        </p>
                                        <p>
                                            <span>可选高度：</span>
                                            <span>{{item.heightName}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="配件列表">
                <van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch(1)" @input="onSearch(1)"
                            @cancel="onSearch(1)" @clear="onSearch(1)">
                    <div slot="action" @click="onSearch(1)">搜索</div>
                </van-search>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(1)">
                    <van-list v-model="loading" :finished="finished" @load="getPartsList" class="listBox" :finished-text="partsFinishText">
                        <div v-for="item in list" class="card" :key="item.uuid" @click="openPartsDetail(item)">
                            <table class="layout">
                                <tr>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{partsShowName.brandIdname}}：{{item.brandIdname}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span>{{partsShowName.parentName}}：</span>
                                            <span>{{item.parentName}}</span>
                                        </p>
                                        <p>
                                            <span>{{partsShowName.name}}：</span>
                                            <span>{{item.name}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
        <div class="recordBox">
            <van-button type="info" size="large" @click="goToCart">进入购物车({{quantity}})</van-button>
        </div>
    </div>
</template>
<script>
    import {Tab, Tabs, Panel, Field, List, Search, Popup, PullRefresh, NavBar, Button} from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
    import configService from "../../service/configService";

    export default {
        data: function () {
            return {
                selected: 0,
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                refreshing: false,
                partsFinishText: "没有更多了",
                type: "0",
                quantity: 0,
                partsShowName: {
                    brandIdname: "品牌",
                    parentName: "系列",
                    name: "型号",
                }
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh
        },
        created: async function () {
            this.type = this.$route.query.type;
            this.selected = parseInt(this.type);
            this.switchTab(parseInt(this.type));
            let resp = await dealerOrderService.getCartQuantity("");
            if (resp.data.Status === "1") {
                this.quantity = resp.data.Data || 0;
            }
            let configValue = await configService.getConfigByName("配件类型显示列");
            if (configValue.data.Status === "1"){
                if (configValue.data.Data && configValue.data.Data.value){
                    let showNames = configValue.data.Data.value;
                    let showNameArr = showNames.split(",");
                    if(showNameArr.length === 3){
                        this.partsShowName.brandIdname = showNameArr[0];
                        this.partsShowName.parentName = showNameArr[1];
                        this.partsShowName.name = showNameArr[2];
                    }
                }
            }
        },
        methods: {
            async getSkuList() {
                this.pageIndex++;
                let resp = await dealerOrderService.getSkuList(this.pageIndex, this.value);
                if (resp.data.Status === "1"){
                    resp.data.Data.data.forEach(item => {
                        if(item.heightName && item.heightName.length > 40){
                            let temp = item.heightName;
                            item.heightName = temp.substring(0, 40);
                            item.heightName += "...";
                        }
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            async getPartsList() {
                this.pageIndex++;
                let resp = await dealerOrderService.getPartsList(this.pageIndex, this.value);
                if (resp.data.Status === "1"){
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                    if(resp.data.Data.total == 0){
                        this.partsFinishText="暂无可选配件";
                    }else{
                        this.partsFinishText="没有更多了";
                    }
                }
            },
            onRefresh(index){
                this.list = [];
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                switch (index) {
                    case 0:
                        this.getSkuList();
                        break;
                    case 1:
                        this.getPartsList();
                        break;
                    default: break;
                }
            },
            onSearch(index){
                this.onRefresh(index);
            },
            switchTab(index) {
                window.scrollTo(0, 0);
                this.value = "";
                this.onRefresh(index)
            },
            openMainDetail(item){
                this.$router.push({path: "skuDetail", query: {type:"main", parentId: "0", categoryId: item.uuid}});
            },
            openPartsDetail(item){
                this.$router.push({path: "skuDetail", query: {type:"parts", parentId: item.parentId, categoryId: item.uuid}});
            },
            goToCart(){
                this.$router.push("skuCart");
            },
            onClickLeft(){
                this.$router.push("dealerOrder");
            },
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 0;
    }
    .card p {
        margin:10px 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .recordBox {
        padding: 0.5rem 0;
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:0;
        position:fixed;
        width: 100%;
    }
</style>